export default __webpack_public_path__ + "static/media/Welcome.d9770fff.jpg";